import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { TenantPage } from 'layouts';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { StatusOption } from 'shared/types/general';
import toast from 'shared/utils/toast';
import { supplierTransportActiveDocumentService } from '../api/supplier-transport-active-document.service';
import { AddButton } from 'components/ui';
import { TransportActiveDocumentColumns } from '../../TransportActiveDocument/transport-active-document';

export function SupplierActiveTransportDocumentList() {
  const { t } = useTranslation();
  const prefix = 'pages.supplier-active-ddt.list';

  const navigate = useNavigate();
  const datagridRefresh = useRef(null);
  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);

  const downloadAttachment = (transportActiveDocumentId) => {
    if (transportActiveDocumentId) {
      supplierTransportActiveDocumentService.downloadAttachment(transportActiveDocumentId);
    }
  };

  const regenerateDocument = (transportActiveDocumentId) => {
    if (transportActiveDocumentId) {
      supplierTransportActiveDocumentService.regeneratePDF(transportActiveDocumentId).then(() => {
        toast.success('PDF rigenerato.');
      });
    }
  };

  useEffect(() => {
    supplierTransportActiveDocumentService.options().then((res) => {
      if (res.actions && res.actions.POST && res.actions.POST.status.choices) {
        const choices = res.actions.POST.status.choices
          .filter((choice) => choice.value !== 0)
          .map((choice) => ({
            ...choice,
            display_name: t(`entities.supplier-active-ddt.${choice.display_name}`)
          }));
        setStatusOptions(choices);
        console.log({ choices }); // For debugging purposes
      }
    });
  }, []);

  const columns = TransportActiveDocumentColumns(
    true,
    downloadAttachment,
    regenerateDocument,
    true // isSupplier
  );

  return (
    <TenantPage
      title={t(`${prefix}.title`)}
      subtitle={t(`${prefix}.subtitle`)}
      menuRight={<AddButton requireTenantAdmin onClick={() => navigate('new')} prefix={prefix} />}>
      <EnhancedDataGrid
        columns={columns}
        service={supplierTransportActiveDocumentService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
}

export default SupplierActiveTransportDocumentList;
